import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdministrationComponent } from './administration.component';
import { AdminSettingsComponent } from './admin-settings/admin-settings.component';
import { MaterialModule } from 'src/app/material.module';
import { SectiuniModule } from './admin-settings/sectiuni/sectiuni.module';
import { TypeImageAdminModule } from './admin-settings/type-image-admin/type-image-admin.module';
import { PermissionsActionAdminModule } from './admin-settings/permissions-action-admin/permissions-action-admin.module';
import { PermisiuniModule } from './admin-settings/permisiuni/permisiuni.module';
import { ConfigAdminModule } from './admin-settings/config-admin/config-admin.module';
import { ModulesModule } from './admin-settings/modules/modules.module';
import { ModuleGroupPermissionModule } from './admin-settings/module-group-permission/module-group-permission.module';
import { ModulePermissionModule } from './admin-settings/module-permission/module-permission.module';
import { UserTypeModule } from './admin-settings/user-type/user-type.module';
import { SourceModule } from './admin-settings/source/source.module';
import { ConfiguratorModuleModule } from './admin-settings/configurator-module/configurator-module.module';
import { CronsModule } from './admin-settings/crons/crons.module';
import { SolicitareRankModule } from './admin-settings/solicitare-rank/solicitare-rank.module';
@NgModule({
  declarations: [AdministrationComponent, AdminSettingsComponent],
  imports: [
    CommonModule,
    MaterialModule,
    SectiuniModule,
    TypeImageAdminModule,
    PermissionsActionAdminModule,
    PermisiuniModule,
    ConfigAdminModule,
    ConfiguratorModuleModule,
    ModulesModule,
    ModuleGroupPermissionModule,
    ModulePermissionModule,
    UserTypeModule,
    SourceModule,
    CronsModule,
    SolicitareRankModule
  ],

  exports: [AdministrationComponent, AdminSettingsComponent],
})
export class AdministrationModule { }
